<div class="input-radio">
  <label *ngIf="label">{{ label }}</label>
  <div style="display: flex; align-items: center; gap: 15px; flex-wrap: wrap">
    <div
      *ngFor="let option of options"
      style="display: flex; align-items: center; gap: 3px"
      (click)="updateControl(option.value)"
    >
      <div class="input-radio-circle" [class.checked]="control?.value === option?.value">
        <i
          *ngIf="control?.value === option?.value"
          class="fa-regular fa-check"
        ></i>
      </div>
      <span>{{ option?.text }}</span>
    </div>
  </div>
</div>
